"use client";
import { useState, Fragment } from "react";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";

import { useStore } from "../../../../../service/mobx";
import { TextFragment } from "./Fragment/Text";
import AnchorFragment from "./Fragment/Anchor";
import ImageFragment from "./Fragment/Image/index";

export default function ArticleSection({
  heading,
  paragraphs,
  index,
  length,
  imgScale,
  avgLineHeight
}) {
  const [open, setOpen] = useState(index === 0);
  const { analytics } = useStore();
  const hasCaption = fragment => fragment.element === "figcaption";

  return (
    <Accordion
      elevation={0}
      key={index}
      component="section"
      expanded={open}
      sx={{
        py: 1,
        m: "0 !important",
        px: { compact: 0, expanded: 2 },
        bgcolor: "surface.container.lowest",
        "&:before": {
          bgcolor: "transparent"
        }
      }}
      TransitionProps={{ timeout: { enter: 300, exit: 250 } }}
    >
      <AccordionSummary
        sx={{ p: 0 }}
        expandIcon={<ExpandMoreIcon sx={{ color: "surface.on.variant" }} />}
        onClick={() => {
          const expanded = !open;

          setOpen(expanded);
          analytics.track.event(`Article ${expanded ? "Expand" : "Collapse"}`, {
            index,
            heading,
            percent: (index + 1) / length
          });
        }}
      >
        <Typography
          variant="titleLg"
          color="surface.on.color"
          sx={{
            textWrap: "balance",
            typography: { compact: "titleMd", expanded: "titleLg" }
          }}
        >
          {heading}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{ px: { compact: 0, expanded: 2 } }}
        className="article-section"
      >
        {paragraphs.map((paragraph, paragraphIndex) => (
          <Typography
            paragraph
            key={paragraphIndex}
            color="surface.on.color"
            variant="paperBody1"
            overflow="hidden"
            sx={{
              textWrap: "pretty",
              ...(paragraph.some(hasCaption)
                ? {
                    textAlign: "center",
                    color: "secondary.color",
                    typography: "paperBody2"
                  }
                : {
                    textAlign: { compact: "left", expanded: "justify" },
                    typography: {
                      compact: "paperBody2",
                      expanded: "paperBody1"
                    }
                  })
            }}
          >
            {paragraph.map((fragment, fragmentIndex) => (
              <Fragment
                // tabindex -1 prevents Chrome mobile's "Touch to Search"
                // tabIndex={-1}
                // position="relative"
                key={fragmentIndex}
              >
                {fragment.element === "span" ||
                fragment.element === "figcaption" ? (
                  <TextFragment fragment={fragment} />
                ) : fragment.element === "img" ? (
                  <ImageFragment
                    fragment={fragment}
                    imgScale={imgScale}
                    avgLineHeight={avgLineHeight}
                  />
                ) : fragment.element === "a" ? (
                  <AnchorFragment fragment={fragment} />
                ) : (
                  console.warn("unknown", { fragment })
                )}
              </Fragment>
            ))}
          </Typography>
        ))}
      </AccordionDetails>
    </Accordion>
  );
}
